'use client';

import { Session } from 'next-auth';
import {
	HeroSection,
	ProblemSection,
	SolutionSection,
	PricingSection,
	CTASection,
	Footer
} from './ui';
import DomainsPageClient from 'app/(dashboard)/domains/domains-client';

export default function NosEmailClient({ initialSession }: { initialSession: Session | null }) {
	return (
		<div className="min-h-screen">
			{initialSession?.user?.email ? (
				// Logged in - show domains dashboard
				<>
					<DomainsPageClient session={initialSession} />
				</>
			) : (
				// Not logged in - show landing page
				<>
					<HeroSection session={initialSession} />
					<ProblemSection />
					<SolutionSection />
					<PricingSection />
					<CTASection />
					<Footer />
				</>
			)}
		</div>
	);
}
